<template>
  <div class="color-picker-container" v-click-outside="focusOut"
       @click="toggleActivePick"
  >
    <div :title="$t('shared.textEditor.textColor')" id="picked-color" :style="styleCurrentColor()">
    </div>
    <div
      class="color-menu"
      v-if="menuActive"
    >
      <template v-for="color in colors">
        <button :key="color" :style="styleButton(color)" @click="action(color)">
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'

export default {
  props: {
    action: {
      type: Function,
      required: true
    },
    other: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      remixiconUrl,
      menuActive: false,
      colors: [ '#000000', '#a0a0a0', '#6699cc', '#0000FF', '#FF0000', '#00cc00', '#debe39' ]

    }
  },
  methods: {
    styleButton(color) {
      if (!color) {
        color = '#000000'
      }
      return 'background-color: ' + color + ';'
    },
    styleCurrentColor () {
      let color = this.other()

      if (color === undefined) {
        color = '#000000'
      }
      return 'background-color: ' + color + ';'
    },
    toggleActivePick() {
      this.menuActive = !this.menuActive
    },
    focusOut() {
      this.menuActive = false
    }
  }
}
</script>

<style lang="scss">
.color-menu {

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background:  #CCE5E9;
    border-radius: 100px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(255, 255, 255) !important;
    border-radius: 100px !important;
    border: 2px solid #CCE5E9 !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background:rgb(243, 252, 255) !important;
  }
  background: #f0f0f0;
  border-radius: 0.4rem;
  border: solid #e0e0e9 1px;
  color: #fff;
  cursor: pointer;
  padding: 0.25rem;
  width: 75px;
  position: absolute;
  overflow: auto;
  height: 60px;
  margin: 5px 0 0 5px;
  z-index: 2;
  white-space: normal;
  text-align: left;

  @media (max-width: $small) {
    position: fixed;
  }

  button {
    width: 17px;
    height: 17px;
    margin:  2px;
    background: none;
    color: #FFF;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0 0.2rem;
    opacity: 0.9;
    border-radius: 20%;
    border: solid #e0e0e0 1px;
    &:hover{
      transform: scale(1.1);
      opacity: 1;
    }
  }
  svg {
    fill: currentColor;
    height: 100%;
    width: 100%;
  }
}
#picked-color{
  border-radius: 50%;
  height: 20px;
  width: 20px;
  border: none;
  outline: none;
  margin-left: 5px;
  -webkit-appearance: none;
  cursor: pointer;
  &:hover{
  opacity: 0.7;
  }
}

#picked-color::-webkit-color-swatch-wrapper {
  padding: 0;
}
#picked-color::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
}
.color-picker-container {
  width: 30px;
  display: inline-block;
  position: relative;
  margin-right: 2px;
  margin-top: 5px;
}
</style>
